import Roof from './roof.js'
let text = window.text; // We depend on global localization

export default class MansardRoof extends Roof {
  constructor(r,p) {
    super(r,p)

    this.inputs = [
      {
        name: "length",
        title: text.length
      },
      {
        name: "width",
        title: text.width
      },
      {
        name: "heightl",
        title: text.heightl,
        alternatives:{
          names: ["anglel"],
          convertTo: function(propertyName, height, values){
            if (propertyName == "heightl"){
              return height;
            }
            return Roof.angle(height,values["width"] - values["wend"])*Roof.radianToDegree();
          },
          convertFrom: function(propertyName, propertyValue, values){
            if (propertyName == "heightl"){
              return propertyValue;
            }
            let angle = propertyValue*Roof.degreeToRadian();
            return Roof.angleToHeight(values["width"] - values["wend"], angle);
          },
        },
      },
      {
        name: "lend",
        title: text.lend
      },
      {
        name: "wend",
        title: text.wend
      },
      {
        name: "lendupper",
        title: text.lendupper
      },
      {
        name: "heightu",
        title: text.heightu,
        alternatives:{
          names: ["angleu"],
          convertTo: function(propertyName, height, values){
            if (propertyName == "heightu"){
              return height;
            }
            return Roof.angle(height,values["wend"])*Roof.radianToDegree();
          },
          convertFrom: function(propertyName, propertyValue, values){
            if (propertyName == "heightu"){
              return propertyValue;
            }
            let angle = propertyValue*Roof.degreeToRadian();
            return Roof.angleToHeight(values["wend"], angle);
          },
        },
      },
    ]

    this.name = text.rMansard
    this.description = text.rdMansard
  }

	pipes() {
		let i = this.props
		return [i.length, i.length, i.width, i.width]
  }
  
  vindski() {
    return 0;
  }

  mone() {
    // For lower part of roof
    let wdiff = (this.props.width - this.props.wend)/2;
    let wflatlowerlongside = Math.sqrt(wdiff*wdiff + this.props.heightl*this.props.heightl);
    // For upper part of roof (upper subroof)
    let wu = this.props.wend/2;
    let aradupperlong = Math.atan2(this.props.heightu, wu);
    let w1 = wu/Math.cos(aradupperlong);

    let diagLow = Math.sqrt(Math.pow(this.props.lend,2) + Math.pow(wflatlowerlongside, 2.0))
    let diagHigh = Math.sqrt(Math.pow(this.props.lendupper,2.0) + w1*w1);
    let sideLong = this.props.length - 2*this.props.lend;
    let sideShort = this.props.wend;
    let top = this.props.length - 2*this.props.lend - 2*this.props.lendupper;

    return top + sideShort*2 + sideLong*2 + diagLow*4 + diagHigh*4;
  }


  validateInput(inputs){
    if (inputs == undefined){
      return undefined;
    }
    let ret = {}
    let hasError = false;
    if (inputs.wend > inputs.width){
      ret["wend"] = text.errWidthEnd
      hasError = true;
    }
    if (inputs.lend > inputs.length/2){
      ret["lend"] = text.errLengthEnd
      hasError = true 
    }
    if (inputs.lendupper > inputs.length-2*inputs.lend){
      ret["lendupper"] = text.errDontFit;
      hasError = true;
    }
    if(hasError){
      return ret;
    }
    return undefined;
  }

  topatches() {
    // For lower part of roof
    let wdiff = 1000*(this.props.width - this.props.wend)/2
    let aradlowerlongside = Math.atan(1000*this.props.heightl,wdiff);

    let wflatlowerlongside = Math.sqrt(wdiff*wdiff + 1000*this.props.heightl*1000*this.props.heightl);
    let wflatlowershortside = 1000*Math.sqrt(this.props.lend*this.props.lend +
                                    this.props.heightl*this.props.heightl);

    // For upper part of roof (upper subroof)
    let wu = this.props.wend/2;
    let araduppershort = Math.atan2(this.props.heightu, wu)
    let aradupperlong = Math.atan2(this.props.heightu, wu)

    let w1 = 1000*wu/Math.cos(aradupperlong)
    let hu = this.props.heightu
    let l1 = 1000*Math.sqrt(this.props.lendupper*this.props.lendupper + hu*hu)
    let lu = this.props.length - this.props.lend*2

    let patches = [
      this.fromarr( // Long side lower
        0, 0,
        1000*this.props.lend, wflatlowerlongside,
        this.props.length*1000 - 1000*this.props.lend, wflatlowerlongside,
        this.props.length*1000, 0
      ),
      this.fromarr( // Long side lower
        0, 0,
        1000*this.props.lend, wflatlowerlongside,
        this.props.length*1000 - 1000*this.props.lend, wflatlowerlongside,
        this.props.length*1000, 0
      ),
      this.fromarr( // short side lower
        0, 0,
        wdiff, wflatlowershortside,
        this.props.width*1000-wdiff, wflatlowershortside,
        1000*this.props.width,0
      ),
      this.fromarr( // short side lower
        0, 0,
        wdiff, wflatlowershortside,
        this.props.width*1000-wdiff, wflatlowershortside,
        1000*this.props.width,0
      ),
      // Upper subroof
      this.fromarr( // upper long side
        0,0,
        1000*(this.props.lendupper),w1,
        1000*(lu-this.props.lendupper), w1,
        1000*lu, 0
      ),
      this.fromarr( // upper long side
        0,0,
        1000*(this.props.lendupper),w1,
        1000*(lu-this.props.lendupper), w1,
        1000*lu, 0
      ),
      this.fromtriangle(1000*this.props.wend,l1 ), // upper triangle
      this.fromtriangle(1000*this.props.wend,l1 ), // upper triangle

    ];

    return patches
  }

  patchtransforms() {
    // For lower part of roof
    let wdiff = 1000*(this.props.width - this.props.wend)/2
    let aradlowerlongside = Math.atan(1000*this.props.heightl,wdiff);

    let wflatlowerlongside = Math.sqrt(wdiff*wdiff + 1000*this.props.heightl*1000*this.props.heightl);
    let wflatlowershortside = 1000*Math.sqrt(this.props.lend*this.props.lend +
                                    this.props.heightl*this.props.heightl);


// For upper part of roof (upper subroof)
    let wu = this.props.wend/2;
    let araduppershort = Math.atan2(this.props.heightu, wu)
    let aradupperlong = Math.atan2(this.props.heightu, wu)

    let w1 = 1000*wu/Math.cos(aradupperlong)
    let hu = this.props.heightu
    let wflatupperlongside = Math.sqrt(hu*hu + wu*wu)
    let l1 = 1000*Math.sqrt(this.props.lendupper*this.props.lendupper + hu*hu)
    let lu = this.props.length - this.props.lend*2

    let bw = 1000*Math.sqrt((this.props.length-this.props.lend*2)*(this.props.length-this.props.lend*2) +
                            this.props.heightl*this.props.heightl)
    bw = 0
    let off = 1000*this.props.width/20

    let ltop = (this.props.length-this.props.lend - this.props.lendupper)

    return [

      {
        t: [-500*this.props.length, -500*(wflatlowerlongside+w1)/1000*2 - off*2],
        r: [0, 0, 0],
      },
      {
        t: [-500*this.props.length, -500*(wflatlowerlongside+w1)/1000*2 - off*2],
        r: [180, 0, 0],
      },
      {
        t: [-500*this.props.width-500*ltop, -wflatlowershortside - l1 - off],
        r: [-90,-500*ltop, 0],
      },
      {
        t: [-500*this.props.width+500*ltop, -wflatlowershortside - l1 - off],
        r: [90, 500*ltop, 0],
      },

      {
        t: [-500*lu, -w1 - off/2],
        r: [0, 0, 0],
      },
      {
        t: [-500*lu, -w1 - off/2],
        r: [180, 0, 0],
      },
      {
        t: [-500*wu*2 - 500*lu + 1000*this.props.lendupper, -l1 -off],
        r: [-90, -500*lu + 1000*this.props.lendupper, 0],
      },
      {
        t: [-500*wu*2 + 500*lu - 1000*this.props.lendupper, -l1-off],
        r: [90, +500*lu - 1000*this.props.lendupper, 0],
      },

    ]
  }

}



// WEBPACK FOOTER //
// ./roofs/mansardroof.js